import { SavedProposal } from "@/types/proposal";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

interface SavedProposalsDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  proposals: SavedProposal[];
  onLoad: (name: string) => void;
  onDelete: (name: string) => void;
}

export const SavedProposalsDialog = ({
  open,
  onOpenChange,
  proposals,
  onLoad,
  onDelete,
}: SavedProposalsDialogProps) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl max-h-[600px] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="text-2xl font-light text-slate-800">Saved Proposals</DialogTitle>
        </DialogHeader>

        {proposals.length === 0 ? (
          <p className="text-slate-500 text-center py-8">No saved proposals found.</p>
        ) : (
          <div className="space-y-3">
            {proposals.map((proposal) => (
              <div
                key={proposal.name}
                className="flex items-center justify-between p-4 border border-slate-200 rounded hover:bg-slate-50"
              >
                <div>
                  <div className="font-medium text-slate-800">{proposal.name}</div>
                  <div className="text-sm text-slate-500">
                    Saved: {new Date(proposal.savedAt).toLocaleDateString()} at{' '}
                    {new Date(proposal.savedAt).toLocaleTimeString()}
                  </div>
                </div>
                <div className="flex space-x-2">
                  <Button
                    onClick={() => {
                      onLoad(proposal.name);
                      onOpenChange(false);
                    }}
                    className="bg-blue-600 hover:bg-blue-700"
                  >
                    Load
                  </Button>
                  <Button
                    onClick={() => onDelete(proposal.name)}
                    variant="destructive"
                  >
                    Delete
                  </Button>
                </div>
              </div>
            ))}
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};
